import { useCallback } from "react";
import { yupResolver } from "@hookform/resolvers/yup";

import Grid from "@mui/material/Grid";

import { FormTextField } from "@covertree/ui";
import { useFormWithNotification } from "@covertree/hooks";
import { FormSelectField } from "@covertree/ui/forms/FormSelectField";

import { useGetClaimDetailsForLossType } from "@hooks/useGetClaimDetailsForLossType";
import { useAppDispatch } from "@redux/hooks";
import { LiabilityClaimReason, LossType } from "@api/operations.generated";
import { StepPath } from "@routing/paths";
import { submitClaimDetails } from "@redux/slices";

import { InjuredPersonsSection } from "../shared/InjuredPersonsSection";
import { ClaimsForm } from "../../ClaimsForm";
import { LiabilityForm, validation } from "./form";

const claimReasonOptions = [
  { label: "Lawsuit", value: LiabilityClaimReason.Lawsuit },
  {
    label: "Medical Payments",
    value: LiabilityClaimReason.MedicalPayments,
  },
  { label: "Other", value: LiabilityClaimReason.Other },
];

export const Liability = () => {
  const dispatch = useAppDispatch();

  const defaultValues = useGetClaimDetailsForLossType();

  const form = useFormWithNotification({
    mode: "all",
    reValidateMode: "onSubmit",
    defaultValues: { ...defaultValues },
    resolver: yupResolver(validation),
  });

  const { control } = form;

  const submit = useCallback((value: LiabilityForm) => {
    dispatch(
      submitClaimDetails({
        value,
        type: LossType.Liability,
      })
    );
  }, []);

  return (
    <ClaimsForm
      form={form}
      onSubmit={submit}
      navigateToStep={StepPath.UPLOAD_CLAIM_DOCUMENTS}
      dataTestId="liability">
      <Grid item xs={12}>
        <FormSelectField
          id="claim-reason"
          dataTestId="claim-reason"
          name="claimReason"
          options={claimReasonOptions}
          label="Claim Reason"
          control={control}
        />
      </Grid>
      <Grid item xs={12}>
        <FormTextField
          id="claim-description"
          dataTestId="claim-description"
          name="claimDescription"
          multiline
          rows={4}
          label="Please provide a description of the loss and how it happened?"
          control={control}
        />
      </Grid>
      <Grid item xs={12}>
        <InjuredPersonsSection />
      </Grid>
    </ClaimsForm>
  );
};
